export const isStringEmptyOrUndefined = (str: string | undefined) => str === '' || str === undefined || str === null;
